import { cn } from '@/lib/utils';
import { Root, CollapsibleContent as RadixCollapsibleContent } from '@radix-ui/react-collapsible';
import {
  forwardRef,
  type ElementRef,
  type ComponentPropsWithoutRef,
} from 'react';

const Collapsible = Root;

const CollapsibleContent = forwardRef<
  ElementRef<typeof RadixCollapsibleContent>,
  ComponentPropsWithoutRef<typeof RadixCollapsibleContent>
>(({ className, ...props }, ref) => (
  <RadixCollapsibleContent
    ref={ref}
    className={cn(
      'overflow-hidden', // data-[state=open]:animate-collapsible-down data-[state=closed]:animate-collapsible-up
      className,
    )}
    {...props}
  />
));

export { Collapsible, CollapsibleContent };
